/**
 * @file The one in-memory proxy that tells every analytics answer on screen to
 * refetch. Written only by `useAnalyticsAnswersRefetch`, which sets
 * `computedAt` each time the caller's own home summary moves to a new
 * computed time after the first one it saw; read through `useSnapshot` by
 * `useAnalyticsAnswer`, which adds it to its run effect's deps. Null until the
 * first move, so mounting never refetches. Nothing here is persisted.
 */
import { proxy } from 'valtio';

export const analyticsAnswersRefetch = proxy<{ computedAt: string | null }>({
  computedAt: null,
});
